import { Grid } from '@bedrock-layout/primitives'
import { Heading, Img, WysiwygBlock } from '@okam/brand-ui/index'
import React from 'react'
import tw, { css } from 'twin.macro'
import { useFragment } from 'gql'
import withForwardedRefSection from 'lib/utils/withForwardedRefSection'
import { blockContestFragment, colorSchemeFragment } from 'query/single-page/fragment'
import type { TPetParentsCornerContestBlock } from '../../types'

const ContestPetParentsCornerBlock = (props: TPetParentsCornerContestBlock) => {
  const { title, colors, content, featured_image: featuredImage } = useFragment(blockContestFragment, props)

  const blockColors = useFragment(colorSchemeFragment, colors)

  return (
    <div
      css={[
        css`
          background-color: ${blockColors?.background};
          ${tw`flex relative flex-col items-start font-semibold py-32 overflow-hidden px-16 md:px-20`}
        `,
      ]}
    >
      <Grid
        gutter="2rem"
        minItemWidth={300}
        css={css`
          grid-template-columns: repeat(auto-fit, 1fr) !important;
          ${tw`w-full`}
        `}
      >
        <Img
          css={css`
            justify-self: end;
            border-radius: 20px;
            aspect-ratio: 1/1;
            object-fit: cover;
          `}
          id={featuredImage?.id}
          filename={featuredImage?.filenameDownload}
          alt={featuredImage?.description ?? ''}
          width={featuredImage?.width ?? 500}
          height={featuredImage?.height ?? 500}
        />
        <div tw="flex flex-col justify-center md:pl-4">
          <Heading tw="pb-4" as="h3" variant="h1">
            {title}
          </Heading>
          <WysiwygBlock tw="md:max-w-[75%]" content={content ?? ''} />
        </div>
      </Grid>
    </div>
  )
}

export default withForwardedRefSection(ContestPetParentsCornerBlock)
